export default __webpack_public_path__ + "static/media/Snd2.f838bef7.mp3";